import React, { Component } from "react";
import Modal from 'react-responsive-modal';
import './exam_stayle';
import ConsultCard from "../../MedicalHistory/ConsultCard";

class ModalPreviewConsult extends Component {
    render(){
        const {open, onClose, consult} = this.props;

        return (
            <Modal open={open} onClose={onClose} center>
                <div style={{ width: '800px', maxHeight: '80vh', overflow: 'auto' }}>
                    <div className="text-center mb-3">
                        <h2>Vista Previa de la Consulta</h2>
                    </div>
                    {consult && (
                        <ConsultCard 
                            consult={consult}
                            patient={consult.patient}
                            restrictHeight={false}
                            hiddePrintButton={true}
                        />
                    )}
                </div>
            </Modal>
        );
    }
}

export default ModalPreviewConsult;